var u = Object.defineProperty;
var i = Object.getOwnPropertySymbols;
var o = Object.prototype.hasOwnProperty, c = Object.prototype.propertyIsEnumerable;
var d = (e, l, t) => l in e ? u(e, l, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[l] = t, p = (e, l) => {
  for (var t in l || (l = {}))
    o.call(l, t) && d(e, t, l[t]);
  if (i)
    for (var t of i(l))
      c.call(l, t) && d(e, t, l[t]);
  return e;
};
var C = (e, l) => {
  var t = {};
  for (var r in e)
    o.call(e, r) && l.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && i)
    for (var r of i(e))
      l.indexOf(r) < 0 && c.call(e, r) && (t[r] = e[r]);
  return t;
};
import * as a from "react";
const m = (r) => {
  var n = r, {
    title: e,
    titleId: l
  } = n, t = C(n, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ a.createElement("svg", p({ width: 32, height: 32, viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": l }, t), e ? /* @__PURE__ */ a.createElement("title", { id: l }, e) : null, /* @__PURE__ */ a.createElement("g", { clipPath: "url(#clip0_2956_10614)" }, /* @__PURE__ */ a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.6822 5.31806C14.967 5.60282 14.967 6.0645 14.6822 6.34926L6.34889 14.6826C6.06413 14.9673 5.60245 14.9673 5.31769 14.6826C5.03294 14.3978 5.03294 13.9361 5.31769 13.6514L13.651 5.31806C13.9358 5.0333 14.3975 5.0333 14.6822 5.31806Z" }), /* @__PURE__ */ a.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.9375 5.83366C5.9375 5.43095 6.26396 5.10449 6.66667 5.10449H14.1667C14.5694 5.10449 14.8958 5.43095 14.8958 5.83366V13.3337C14.8958 13.7364 14.5694 14.0628 14.1667 14.0628C13.764 14.0628 13.4375 13.7364 13.4375 13.3337V6.56283H6.66667C6.26396 6.56283 5.9375 6.23637 5.9375 5.83366Z" })));
};
export {
  m as default
};
